import { DEFAULT_ICON_PROPS, IIconProps } from '../constants';

export const XBlackIcon = ({ ariaLabel = 'X', ...props }: IIconProps) => {
  const { size, width, height, title, ariaHidden, className } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={size ?? width}
      height={size ?? height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={ariaLabel}
      aria-hidden={ariaHidden}
      className={`block ${className}`}
      {...props}
    >
      {title && <title>{title}</title>}
      {/* The X mark is knocked out of the black square, so the white rect below shows through it. */}
      <rect width="32" height="32" rx="4" fill="white" />
      <path
        d="M12.224 8.21915L23.1447 23.7809H20.2415L9.34012 8.21915H12.224ZM32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4ZM26.7404 25.697L18.6221 14.08L25.2587 6.30303H22.7161L17.472 12.4315L13.1918 6.30303H5.72509L13.3682 17.2276L6.12072 25.697H8.70594L14.5261 18.8781L19.2931 25.697H26.7404Z"
        fill="#000000"
      />
    </svg>
  );
};
